// removed by extract-text-webpack-plugin
module.exports = {"content":"calendar__content-2p0-O","monthName":"calendar__monthName-2RBZi","weekTitleText":"calendar__weekTitleText-ebHPL","table":"calendar__table-vSKQT","item":"calendar__item-26cWO","_notInPeriod":"calendar___notInPeriod-3hWrJ","itemText":"calendar__itemText-2UwjO","year":"calendar__year-2o1AS","_isDisabled":"calendar___isDisabled-3kb53","month":"calendar__month-1yXVZ","_isInRange":"calendar___isInRange-To4Q7","_isBoundOfRange":"calendar___isBoundOfRange-1wLQA"};


//////////////////
// WEBPACK FOOTER
// ./packages/account-ui/calendar/calendar.css
// module id = 865
// module chunks = 0